import { render, staticRenderFns } from "./StaticIdCardList.vue?vue&type=template&id=62fc41ea&scoped=true&"
import script from "./StaticIdCardList.vue?vue&type=script&lang=js&"
export * from "./StaticIdCardList.vue?vue&type=script&lang=js&"
import style0 from "./StaticIdCardList.vue?vue&type=style&index=0&id=62fc41ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fc41ea",
  null
  
)

export default component.exports